module.exports = __webpack_public_path__ + "static/media/basico.8b40c302.md";